/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type EvmAddressSummaryInfo = {
    ADT: EvmAddressSummaryInfo.ADT;
    ADDR: string;
    NN: string;
    SB: string;
};

export namespace EvmAddressSummaryInfo {

    export enum ADT {
        EOA = 'EOA',
        CA = 'CA',
    }


}

